import type { ChangeRequestView } from "@KassaroAB/shared/types/changeRequest";

export const normalizeChangeRequestViewRequired = (
  changeRequest: ChangeRequestView,
): ChangeRequestView => ({
  ...changeRequest,
  context: changeRequest.context ?? {},
});

export const normalizeChangeRequestView = (
  changeRequest: ChangeRequestView | null,
): ChangeRequestView | null =>
  changeRequest === null ? null : normalizeChangeRequestViewRequired(changeRequest);
